import React from 'react';

const Resize = React.createContext({
  breakpoint: null,
  windowWidth: null,
});

export default Resize;
